import React from 'react';
import loadingImage from '../../assets/images/loadingImg.gif';
import './styles.scss';
import { classnames } from '../../utils';

export default function Loading() {
    return (
        <div className="loadingImageContainer">
            <img src={loadingImage} width={50} />
        </div>
    );
}


export const InlineLoading: React.FC<{ size?: Size }> = (props) => {
    return (
        <div className={classnames({ "inline--loading": true, [props.size as string]: !!props.size })}>
            <img src={loadingImage} width={30} />
        </div>
    )
}